export default {"src":"/_next/static/media/flash.a0fc6a7a.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};